import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mini-verification-overlay flex-center" }
const _hoisted_2 = { class: "mini-verification" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "mini-title flex-center" }, "Contact Verification", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "mini-heading flex-center" }, "Verify your identity so Opt can schedule your meeting and handle the payment", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "contents loader"
}
const _hoisted_6 = {
  key: 1,
  class: "contents"
}
const _hoisted_7 = { class: "verification-method" }
const _hoisted_8 = {
  key: 0,
  class: "input-boxes"
}
const _hoisted_9 = {
  key: 1,
  class: "input-boxes"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = {
  key: 2,
  class: "terms-check"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "flex-label",
  for: "checkbox"
}, [
  /*#__PURE__*/_createTextVNode("By signing up I agree to the "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.google.com" }, "terms of service"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.google.com" }, "privacy policy")
], -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "button-container-mini"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 2,
  class: "contents code-section"
}
const _hoisted_17 = { class: "input-body" }
const _hoisted_18 = { class: "description" }
const _hoisted_19 = {
  key: 0,
  class: "error"
}
const _hoisted_20 = {
  key: 1,
  class: "hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode($setup["VLoader"])
          ]))
        : (!$setup.codeSent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["contents-body", {'signup': !$setup.props.isLogin}])
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode($setup["VRadioset"], {
                    class: "radioset",
                    row: "",
                    label: "Send Verification Code to",
                    options: $setup.verificationRadioOptions,
                    modelValue: $setup.verificationSelection,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.verificationSelection) = $event))
                  }, null, 8 /* PROPS */, ["options", "modelValue"])
                ]),
                ($setup.props.isLogin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      ($setup.verificationSelection === 'email')
                        ? (_openBlock(), _createBlock($setup["vtextfield"], {
                            key: 0,
                            class: "u-info",
                            label: "Email",
                            modelValue: $setup.email,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.email) = $event))
                          }, null, 8 /* PROPS */, ["modelValue"]))
                        : ($setup.verificationSelection === 'phone')
                          ? (_openBlock(), _createBlock($setup["VPhoneInput"], {
                              key: 1,
                              class: "phone u-info",
                              label: "Phone Number",
                              modelValue: $setup.phone,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.phone) = $event))
                            }, null, 8 /* PROPS */, ["modelValue"]))
                          : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode($setup["vtextfield"], {
                        class: "u-info",
                        label: "First Name",
                        modelValue: $setup.firstname,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.firstname) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _createVNode($setup["vtextfield"], {
                        class: "u-info",
                        label: "Last Name",
                        modelValue: $setup.lastname,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.lastname) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _createVNode($setup["vtextfield"], {
                        class: "u-info",
                        label: "Email",
                        modelValue: $setup.email,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.email) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _createVNode($setup["VPhoneInput"], {
                        class: "phone u-info",
                        label: "Phone Number",
                        modelValue: $setup.phone,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.phone) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      ($setup.env == 'development')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_10, "Real number or 555-555-0100 to 0199"))
                        : _createCommentVNode("v-if", true)
                    ])),
                _createElementVNode("div", _hoisted_11, _toDisplayString($setup.errorMsg), 1 /* TEXT */),
                (!$setup.props.isLogin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode($setup["VCheckbox"], {
                        class: "checkbox",
                        modelValue: $setup.acceptedTerms,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.acceptedTerms) = $event))
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _hoisted_13
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */),
              (!$setup.loading && !$setup.codeSent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "outline",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
                    }, "Cancel"),
                    _createElementVNode("button", {
                      class: "primary sendCode",
                      onClick: $setup.doSendCode,
                      disabled: (!$setup.acceptedTerms && !$props.isLogin) || !$setup.codeSentTo
                    }, "Send Code", 8 /* PROPS */, _hoisted_15)
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, "We sent your code to " + _toDisplayString($setup.codeSentTo), 1 /* TEXT */),
                ($setup.errorMsg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.errorMsg), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createVNode($setup["VCodeInput"], {
                  modelValue: $setup.inputCode,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.inputCode) = $event)),
                  length: 5
                }, null, 8 /* PROPS */, ["modelValue"]),
                ($setup.isDevEnvironment && $setup.DEV_code)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "DEV HINT: Your code is " + _toDisplayString($setup.DEV_code), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
    ])
  ]))
}